import React from 'react'

import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'
import WarningIcon from '@material-ui/icons/Warning'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { SET_LAYER_LOAD_FAILED, SET_LAYER_LOAD_IN_PROGRESS } from 'drawer/tabs/layers/actions'

const styles = theme => ({
  root: {},
  loadingSpinner: {
    color: 'grey',
    verticalAlign: 'inherit'
  },
  warningicon: {
    width: 20,
    opacity: 0.54,
    color: 'red'
  }
})

class LayerLoadStatus extends React.PureComponent {
  render () {
    const { classes, about, loadstatus } = this.props

    let statusMarkup = null
    if (loadstatus === SET_LAYER_LOAD_FAILED) {
      let warningMarkup = <WarningIcon className={classes.warningicon} />

      const aboutURL = about?.url
      if (aboutURL) {
        warningMarkup = (
          <a href={aboutURL} alt="About dataset" target="_blank" rel="noopener noreferrer">
            { warningMarkup }
          </a>
        )
      }

      const tooltipText = 'The layer failed to load'
      statusMarkup = <Tooltip title={tooltipText}>{warningMarkup}</Tooltip>
    } else if (loadstatus === SET_LAYER_LOAD_IN_PROGRESS) {
      statusMarkup = <CircularProgress className={classes.loadingSpinner} size={20} />
    }

    // console.log('LayerLoadStatus', titleid, loadstatus)
    return statusMarkup
  }
}

LayerLoadStatus.propTypes = {
  classes: PropTypes.object.isRequired,
  titleid: PropTypes.string.isRequired,
  loadstatus: PropTypes.string,
  about: PropTypes.object
}

function mapStateToProps (state, ownProps) {
  const about = state.layers[ownProps.titleid]?.about
  const loadstatus = state.layers[ownProps.titleid]?.loadstatus
  return {
    about,
    loadstatus
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(LayerLoadStatus)
  )
)
